const trimTrailingSlash = (value) => value.replace(/\/+$/, '');

const PRODUCTION_AUTH_HOST = 'auth.datafre8.com';
const PRODUCTION_ONBOARDING_HOST = 'www.datafre8.com';
const STAGING_AUTH_HOST = 'stg-auth.datafre8.com';
const STAGING_ONBOARDING_HOST = 'stg-www.datafre8.com';
const LOCAL_ONBOARDING_BASE_URL = 'http://localhost:3002';
const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1']);
const LOCAL_NON_ONBOARDING_PORTS = new Set(['3000', '3001']);

const getEnvBaseUrl = () => {
  if (process.env.REACT_APP_ONBOARDING_BASE_URL) {
    return process.env.REACT_APP_ONBOARDING_BASE_URL;
  }
  if (process.env.REACT_APP_PUBLIC_ONBOARDING_BASE) {
    return process.env.REACT_APP_PUBLIC_ONBOARDING_BASE;
  }
  return '';
};

const normalizeLocalEnvBaseUrl = (envBase) => {
  const trimmedEnvBase = trimTrailingSlash(envBase);

  try {
    const parsedEnvBase = new URL(trimmedEnvBase);
    const isLocalAuthSession = LOCAL_HOSTNAMES.has(window.location.hostname);
    const isLocalEnvBase = LOCAL_HOSTNAMES.has(parsedEnvBase.hostname);

    if (
      isLocalAuthSession &&
      isLocalEnvBase &&
      LOCAL_NON_ONBOARDING_PORTS.has(parsedEnvBase.port)
    ) {
      return LOCAL_ONBOARDING_BASE_URL;
    }
  } catch (error) {
    return trimmedEnvBase;
  }

  return trimmedEnvBase;
};

export const getOnboardingBaseUrl = () => {
  const envBase = getEnvBaseUrl();
  if (envBase) {
    return normalizeLocalEnvBaseUrl(envBase);
  }
  if (window.location.hostname === 'localhost') {
    return LOCAL_ONBOARDING_BASE_URL;
  }
  if (window.location.hostname === PRODUCTION_AUTH_HOST) {
    return `${window.location.protocol}//${PRODUCTION_ONBOARDING_HOST}`;
  }
  if (window.location.hostname === STAGING_AUTH_HOST) {
    return `${window.location.protocol}//${STAGING_ONBOARDING_HOST}`;
  }
  return trimTrailingSlash(window.location.origin);
};
